import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bs-date-calendar__year-step"
}
const _hoisted_2 = {
  key: 1,
  class: "bs-date-calendar__month-step"
}
const _hoisted_3 = {
  key: 2,
  class: "bs-date-calendar__date-step"
}
const _hoisted_4 = { class: "date-step__header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m15 18-6-6 6-6" })
], -1)
const _hoisted_6 = { class: "header__title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m9 18 6-6-6-6" })
], -1)
const _hoisted_8 = { class: "date-step__dates" }
const _hoisted_9 = { class: "dates__table" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "пн"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "вт"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ср"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "чт"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "пт"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "сб"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "вс")
  ])
], -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "table__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calendar_button = _resolveComponent("calendar-button")!
  const _component_calendar_control = _resolveComponent("calendar-control")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-date-calendar", {
            'bs-date-calendar--disabled': _ctx.disabled
        }])
  }, [
    (_ctx.view.step === 'year')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearsForSelectCount, (_, i) => {
            return (_openBlock(), _createBlock(_component_calendar_button, {
              key: `year-${i}`,
              disabled: _ctx.disabled,
              onClick: ($event: any) => (_ctx.onSelectYear(_ctx.view.currentYear + i))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.view.currentYear + i), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]))
          }), 128))
        ]))
      : (_ctx.view.step === 'month')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MONTHS, (month, i) => {
              return (_openBlock(), _createBlock(_component_calendar_button, {
                key: `month-${i}`,
                disabled: _ctx.disabled,
                onClick: ($event: any) => (_ctx.onSelectMonth(i))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(month), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]))
            }), 128))
          ]))
        : (_ctx.view.step === 'date')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_calendar_control, {
                  disabled: _ctx.disabled,
                  onClick: _ctx.onSelectPreviousMonth
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.MONTHS[_ctx.view.selectedMonth as number]) + " " + _toDisplayString(_ctx.view.selectedYear), 1),
                _createVNode(_component_calendar_control, {
                  disabled: _ctx.disabled,
                  onClick: _ctx.onSelectNextMonth
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_ctx.view.dates.length / 7), (week) => {
                      return (_openBlock(), _createElementBlock("tr", { key: week }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.view.dates.slice((week - 1) * 7, week * 7), (day) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: day.toISOString(),
                            class: _normalizeClass({
                                    'is-disabled': _ctx.disabled,
                                    'is-selected': _ctx.isDateSelected(day),
                                    'is-other-month': day.getMonth() !== _ctx.view.selectedMonth
                                }),
                            onClick: ($event: any) => (_ctx.onUpdate(day))
                          }, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(day.getDate()), 1)
                          ], 10, _hoisted_11))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ], 2))
}